import { render, staticRenderFns } from "./selectListRecycle.vue?vue&type=template&id=5880f338&scoped=true&"
import script from "./selectListRecycle.vue?vue&type=script&lang=js&"
export * from "./selectListRecycle.vue?vue&type=script&lang=js&"
import style0 from "./selectListRecycle.vue?vue&type=style&index=0&id=5880f338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5880f338",
  null
  
)

export default component.exports